export const TASK_EVENT_LABELS = {
  'workflow.target-matched': (p) => `Workflow ${p.workflow_name} geïnitialiseerd`,
  'task.created': () => 'Taak gëinitialiseerd',
  'task-queue.entered': (p) => `In queue ${p.task_queue_name} geplaatst`,
  'workflow.entered': (p) => `In workflow ${p.workflow_name} geplaatst`,
  'reservation.created': () => 'Aangeboden aan agent',
  'reservation.timeout': () => 'Gemist door agent',
  'task-queue.moved': () => 'Andere Queue wordt geladen',
  'task-queue.timeout': (p) => `Timeout bereikt van ${p.task_queue_name}`,
  'reservation.accepted': () => 'Geaccepteerd door agent',
  'reservation.rejected': () => 'Geweigerd door agent',
  'task.completed': () => 'Taak voldaan',
  'reservation.completed': () => 'Taak voldaan door agent'
};
